import { render, staticRenderFns } from "./principleFoodCourtsTable.vue?vue&type=template&id=a5c2a234&scoped=true&"
import script from "./principleFoodCourtsTable.vue?vue&type=script&lang=js&"
export * from "./principleFoodCourtsTable.vue?vue&type=script&lang=js&"
import style0 from "./principleFoodCourtsTable.vue?vue&type=style&index=0&id=a5c2a234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c2a234",
  null
  
)

export default component.exports